import React from "react";
import { SVGProps } from "react";

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
      pointerEvents={"none"}
      {...props}
    >
      <path
        fill="var(--task-eva-select-arrow)"
        d="M6.786 10.135l4.905-4.906a1.053 1.053 0 00-.746-1.8h-9.81a1.056 1.056 0 00-.746 1.8l4.906 4.906a1.054 1.054 0 001.49 0z"
      ></path>
    </svg>
  );
}

export default Icon;
